let userState;

if (window.localStorage.getItem("user")) {
  userState = JSON.parse(window.localStorage.getItem("user"));
} else {
  userState = null; 
} 


export const authReducer = (state = userState, action) => {
  switch (action.type) {
    case "LOGGED_IN_USER":
      return { ...state, ...action.payload };
    case "LOGOUT":
      return action.payload;
    default:
      return state;
  }
};
